import { cva } from 'class-variance-authority';

const separator = cva(
  'before:mx-2 before:inline-block before:text-gray-300 before:content-["|"]',
);

export default separator;
